import activityLogAr from './ar.json'

const messages = {
  ar: {
    ...activityLogAr,
  },
}

export default messages
